import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haSurveyPatientSearchPipe'
})
export class HaSurveyPatientSearchPipePipe implements PipeTransform {

  transform(patData: any[], searchpatientdataa: string): any[] {
    if (!patData || !searchpatientdataa) { return patData; }

    // patData.forEach(element => {
    //   if(element.DoctorName==null ){
    //     element.DoctorName="";
    //   }
    //   if(element.Mobile_no==null ){
    //     element.Mobile_no="";
    //   }
    //   if(element.Email_id==null ){
    //     element.Email_id="";
    //   }
    // });
    return patData.filter(ad =>


      ad.fullName.toLowerCase().indexOf(searchpatientdataa.toLowerCase().trim()) !== -1 ||
      ad.patientId.toLowerCase().indexOf(searchpatientdataa.toLowerCase().trim()) !== -1 



    );
  }

}
